import { render, staticRenderFns } from "./RolesCheckbox.vue?vue&type=template&id=e4694a14&scoped=true&"
import script from "./RolesCheckbox.vue?vue&type=script&lang=js&"
export * from "./RolesCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./RolesCheckbox.vue?vue&type=style&index=0&id=e4694a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4694a14",
  null
  
)

export default component.exports